import React, {useState, useEffect, useRef, useMemo} from "react";
import { ReactComponent as CaretDown } from '../../images/svg/ArrowDownSmall.svg'
import styles from "./SelectInput.module.scss";

export const OPEN_DIRECTION_UP = 'up';
export const OPEN_DIRECTION_DOWN = 'down';

export const SELECT_INPUT_TYPE_BLUE = 'SELECT_INPUT_TYPE_BLUE';
export const SELECT_INPUT_TYPE_GREY = 'SELECT_INPUT_TYPE_GREY';

function SelectInput(props) {
    const {
        value,
        setValue,
        label,
        placeholder,
        openDirection = OPEN_DIRECTION_DOWN,
        type = SELECT_INPUT_TYPE_BLUE,
        options,
        disabled = false,
        fullWidth = false,
    } = props;


    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Find the label for the current value
    const selectedOption = options.find(option => option?.value === value);
    const selectedLabel = selectedOption ? selectedOption.label : placeholder;

    const toggleOpen = () => {
        setIsOpen(prev => !prev);
    };

    const handleOptionClick = (selected) => {
        setValue(selected.value);
        setIsOpen(false);
    };

    const inputClassNames = useMemo(() => {
        if (type === SELECT_INPUT_TYPE_GREY) {
            return {
                container: styles.selectInputContainer,
                inputContainer: styles.inputContainer,
                input: styles.inputGrey,
            };
        }

        return {
            container: styles.selectInputContainer,
            inputContainer: styles.inputContainer,
            input: styles.inputBlue,
        };
    }, [type]);

    return (
        <div className={styles.selectInputContainer} style={{width: fullWidth ? '100%' : 'fit-content'}} ref={containerRef}>
            {label &&<span className={styles.label}>{label}</span>}
            <div className={styles.inputContainer} style={{width: fullWidth ? '100%' : 'fit-content'}} ref={containerRef} >
                <div
                    className={inputClassNames.input}
                    style={{width: fullWidth ? '100%' : 'fit-content'}}
                    onClick={toggleOpen}>
                    <span className={styles.label}>{selectedLabel}</span>
                    <CaretDown className={isOpen ? styles.caretIconRotated : ''} />
                </div>
                {isOpen && (
                    <div className={`${styles.dropdownInput} ${openDirection === OPEN_DIRECTION_UP ? styles.dropdownInputUp : ''}`}>
                        {options.map(option => (
                            <div
                                key={option?.value}
                                className={option?.value === value ? styles.dropdownOptionSelected :styles.dropdownOption}
                                onClick={() => handleOptionClick(option)}
                            >
                                {option?.label}
                            </div>
                        ))}
                        {options.length === 0 && (
                            <div className="px-4 py-2 text-gray-500">No options available</div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default SelectInput;
